import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingSpinner } from '@shared/components/LoadingSpinner';
import { UserContext } from '@/shared/contexts/UserContext';
import { hasOnboardingIntent } from '@shared/utils/onboardingIntent';

const OAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { ssoLogin, user } = useContext(UserContext);
  const [loginComplete, setLoginComplete] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [preLoginPath, setPreLoginPath] = useState<string | null>(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');

        if (!code) {
          navigate('/my-reviews', { replace: true });
          return;
        }

        sessionStorage.setItem('ssoCode', code);

        const storedPath = sessionStorage.getItem('preLoginPath');
        sessionStorage.removeItem('preLoginPath');
        setPreLoginPath(storedPath);

        await ssoLogin();
        setLoginComplete(true);
      }
      catch (error) {
        console.error('OAuth callback failed:', error);
        setLoginError(true);
      }
    };

    handleCallback();
  }, []);

  useEffect(() => {
    if (loginError) {
      navigate('/sign-in?error=oauth_failed', { replace: true });
      return;
    }
    if (!loginComplete || !user) return;

    const hasIntent = hasOnboardingIntent();
    const needsOnboarding = !user.networkOnboardingComplete;

    if (needsOnboarding || hasIntent) {
      navigate('/onboarding', { replace: true });
    }
    else {
      navigate(preLoginPath || '/my-reviews', { replace: true });
    }
  }, [loginComplete, loginError, user, navigate, preLoginPath]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <LoadingSpinner variant="circular" size="large" message="Completing sign in..." fullScreen />
    </div>
  );
};

export default OAuthCallback;
